import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_array } from "@swc/helpers/_/_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Center, Loader, useId } from '@coveord/plasma-mantine';
import { clsx } from 'clsx';
import { createContext, forwardRef, useContext } from 'react';
import InfiniteScrollWrapper from 'react-infinite-scroll-component';
import classes from './InfiniteScroll.module.css';
var InfiniteScrollContext = /*#__PURE__*/ createContext(null);
var InfiniteScrollProvider = function InfiniteScrollProvider(_0) {
    var children = _0.children, props = _object_without_properties(_0, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(InfiniteScrollContext.Provider, {
        value: props,
        children: children
    });
};
var _InfiniteScroll = /*#__PURE__*/ forwardRef(function(_0, _1) {
    var _ref = [
        _0,
        _1
    ], _ref1 = _to_array(_ref), _ref2 = _ref1[0], _rest = _ref1.slice(1), children = _ref2.children, props = _object_without_properties(_ref2, [
        "children"
    ]), _rest1 = _sliced_to_array(_rest, 1), ref = _rest1[0];
    var id = useId();
    var infiniteScroll = useContext(InfiniteScrollContext);
    if (infiniteScroll === null) {
        throw new Error('InfiniteScroll must be wrapped by an InfiniteScroll.Provider');
    }
    return /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({}, props), {
        className: clsx(classes.root, props.className),
        id: id,
        ref: ref,
        children: /*#__PURE__*/ _jsx(InfiniteScrollWrapper, _object_spread_props(_object_spread({
            loader: /*#__PURE__*/ _jsx(Center, {
                children: /*#__PURE__*/ _jsx(Loader, {})
            }),
            scrollableTarget: id
        }, infiniteScroll), {
            className: classes.scrollContainer,
            children: children
        }))
    }));
});
_InfiniteScroll.Provider = InfiniteScrollProvider;
_InfiniteScroll.displayName = '@components/mantine/InfiniteScroll';
export var InfiniteScroll = _InfiniteScroll;

//# sourceMappingURL=InfiniteScroll.js.map